import * as React from 'react';
import * as propTypes from 'prop-types';

const VideoIcon = (props) => {
  const { className } = props;

  return (
    <svg
      width="22px"
      height="16px"
      viewBox="0 0 22 16"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      className={className}
    >
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g fill="currentColor" fillRule="nonzero">
          <path
            d="M21.987659,6.12500752 C21.9796609,5.67506362 21.9446588,5.106165 21.8834696,4.41883705 C21.8219363,3.73111506 21.733915,3.11650841 21.6194486,2.57497332 C21.4884701,1.96671501 21.204024,1.45416336 20.7662394,1.0374935 C20.3284548,0.620736079 19.8189029,0.379148994 19.2376267,0.312381995 C17.4205259,0.104200301 14.6746647,0 10.999957,0 C7.3252063,0 4.57930207,0.104200301 2.7623303,0.312381995 C2.18114013,0.379105213 1.67360924,0.620736079 1.23995262,1.0374935 C0.806124005,1.45403202 0.523741952,1.96658366 0.392763464,2.57497332 C0.270127007,3.11668354 0.177934663,3.73124641 0.116573435,4.41883705 C0.0552982061,5.106165 0.0204680763,5.67484471 0.012341046,6.12500752 C0.00404201507,6.57499521 0,7.19993433 0,8 C0,8.79997811 0.00404201507,9.42509235 0.0123840462,9.87499248 C0.0205110765,10.3252429 0.0553412063,10.893835 0.116616435,11.5811192 C0.177977663,12.2687974 0.265998991,12.883404 0.380594419,13.4250267 C0.511572907,14.0334601 0.795932967,14.5459242 1.2338036,14.9624189 C1.67176023,15.3790888 2.18135513,15.6207197 2.7623733,15.6874429 C4.57934507,15.8958435 7.3250773,16 11,16 C14.6750517,16 17.4205689,15.8958435 19.2376697,15.6874429 C19.8189459,15.6207634 20.3262618,15.3790888 20.7600904,14.9624189 C21.193919,14.5458804 21.476129,14.0331536 21.6071075,13.4250267 C21.72983,12.883404 21.8219363,12.2687974 21.8834696,11.5811192 C21.9446588,10.8938788 21.9794029,10.3249802 21.987659,9.87499248 C21.995872,9.42509235 22,8.79997811 22,8 C22,7.19993433 21.995915,6.57499521 21.987659,6.12500752 Z M15.3460262,8.67502531 L9.06039177,12.6748721 C8.94575334,12.7581885 8.80647582,12.7998249 8.64286021,12.7998249 C8.52018076,12.7998249 8.39333028,12.7663757 8.2623948,12.69974 C7.99235379,12.5499193 7.85737629,12.3164756 7.85737629,11.9998905 L7.85737629,4.00015324 C7.85737629,3.68365577 7.99239679,3.45021207 8.2623948,3.30025995 C8.54073483,3.15004515 8.80664782,3.15845122 9.06039177,3.32525927 L15.3460692,7.32514982 C15.5915141,7.46656451 15.7142366,7.6916897 15.7142366,8.00004378 C15.7142366,8.30826652 15.5914711,8.53347927 15.3460262,8.67502531 Z"
            id="Shape"
          />
        </g>
      </g>
    </svg>
  );
};

VideoIcon.propTypes = {
  className: propTypes.string.isRequired,
};

export default VideoIcon;
